import { useNavigate } from "react-router-dom"
import { useT } from "../i18n/index.tsx"
import { Alert, Button, PageHeader } from "../ui/index.ts"

/**
 * 기기 등록 QR 주소(`/app/pair#t=...`)를 **브라우저가 직접 열었을 때** 나오는 화면.
 *
 * 이 QR 은 cooltrack 스캐너 앱의 카메라가 읽는 것이다. 일반 QR 앱이나 브라우저로 열면
 * 여기로 온다 — 안내 없이 대시보드로 보내면 사람이 무슨 일인지 알 수 없다.
 *
 * 토큰은 주소의 **조각(#)** 에 있어 서버로 전송되지 않는다. 이 화면도 토큰을 읽지 않는다.
 */
export function AppPairInfoPage() {
  const t = useT()
  const navigate = useNavigate()

  return (
    <div className="app-pair-info">
      <PageHeader title={t("devices.pairPageTitle")} />
      <Alert
        tone="info"
        title={t("devices.pairPageHint")}
        actions={
          <Button variant="primary" icon="chevronLeft" onClick={() => void navigate("/settings")}>
            {t("devices.pairPageBack")}
          </Button>
        }
      >
        {t("devices.pairPageBody")}
      </Alert>
    </div>
  )
}
